//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: "lifeHelp",
    components: {
        //BottomNav,
    },
    data() {
        return {
            list: []
        };
    },
    methods: {
        getProjectPhones() {
            let projectId = localStorage.getItem('Select-ProjectId');
            if (!projectId) {
                return
            }
            var page = {
                projectId: projectId,
                maxResultCount: 20,
                skipCount: 0
            };
            abp.ajax.post('/api/services/app/Project/SearchContactNumbers', page).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                // this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                // this.loading = false;
            });
        }
    },
    created() {
        this.getProjectPhones();
    }
}
